import io from "socket.io-client";
const wsURL = 'ws'+process.env.REACT_APP_SERVER_URL.slice(4)+'/team/'
const socket = io.connect(wsURL);

socket.on("connect", (socket) => {});

export default socket;
